import Localize from 'react-intl-universal';
import { Link as RouterLink } from 'react-router-dom';

import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';

import { isFraunhofer, setLanguage } from '@common/Util';

const FooterLink = ({ linkName = '', to = '/' }) => {
  const theme = useTheme();

  if (!linkName) {
    return null;
  }

  const externalLinkOnMeaPage = isFraunhofer();

  return theme?.footer?.[linkName] ? (
    externalLinkOnMeaPage ? (
      <Link
        sx={{
          color: theme.footer.color,
          textDecoration: 'none',
          paddingRight: '1rem',
          fontSize: '1rem'
        }}
        component={RouterLink}
        to={to}
      >
        {Localize.get(`Footer.${linkName}`)}
      </Link>
    ) : (
      <Link
        sx={{
          color: theme.footer.color,
          textDecoration: 'none',
          paddingRight: '1rem',
          fontSize: '1rem'
        }}
        target='_blank'
        rel='noopener noreferrer'
        href={
          theme?.footer?.[linkName]?.[setLanguage().toLowerCase()] ||
          theme?.footer?.[linkName]?.['en']
        }
      >
        {Localize.get(`Footer.${linkName}`)}
      </Link>
    )
  ) : null;
};

export default FooterLink;
